/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'
/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Actions
 */
import {
    issueViewQuoteVariation,
    inviteQuoteVariation,
    bindQuoteVariation,
    getQuoteSingle,
    handleReissueQuote,
    confirmEditQuote,
    fetchLocations,
    checkSoftReferral,
    postSoftReferral,
    fecthRenewPolicy,
} from '../../../actions'

/**
 * Import
 * - Page component
 */
import ViewQuote from '../../../components/pages/Quote/ViewQuote/ViewQuote'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: state.quotesSingle,
        step05: state.step05,
        step05Bind: state.quote.step05,
        riskLocations: state.quote.riskLocations,
        softReferrals: state.step05.softReferrals,
        postSoftRef: state.step05.postSoftRef,
        isCollectors: get(state, 'quotesSingle.response.isCollectors', false),
        isMuseums: get(state, 'quotesSingle.response.isMuseums', false),
        isDealersStock: get(state, 'quotesSingle.response.isDealersStock', false),
        isWineSpirits: get(state, 'quotesSingle.response.isWineSpirits', false),
        isCommercialProperty: get(state, 'quotesSingle.response.isCommercialProperty', false),
    }
}

export default connect(
    mapStateToProps,
    {
        issueViewQuoteVariation: issueViewQuoteVariation,
        inviteQuoteVariation: inviteQuoteVariation,
        bindQuoteVariation: bindQuoteVariation,
        postSoftReferral: postSoftReferral,
        checkSoftReferral: checkSoftReferral,
        handleReissueQuote: handleReissueQuote,
        getQuoteSingle: getQuoteSingle,
        confirmEditQuote,
        fetchLocations,
        fecthRenewPolicy,
    }
)(ViewQuote)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Quote/ViewQuote.tsx